import React, { Component } from 'react';
import { PieChart, Pie, Tooltip, Cell, Text } from 'recharts';

class LabeledPieChart extends Component {

  customizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, value }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <Text
        x={x} y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central">

        {`${(percent * 100).toFixed(0)}%`}

      </Text>
    );
  };

  render() {

    const { width,
            height,
            data } = this.props;

    let pieChart = "";
    if(data) {
      pieChart = (

        <PieChart
          width={width} height={height}>

          <Pie
            data={data} dataKey="식대금액PIE"
            innerRadius={30} outerRadius={100}
            startAngle={90} endAngle={-270}
            isAnimationActive={false}
            labelLine={false} label={this.customizedLabel}>
            {
              data.map((entry, idx) => {
                const color = entry.color;
                return <Cell key={'pie-' + idx} fill={color}/>
              })
            }
          </Pie>

        </PieChart>
      );
    }
    //  else {
    //   pieChart = <div className="mid"><h3>데이터 내역이 없습니다.</h3></div>;
    // }

    return(
      <div style={{width:width, height:height}} className="inBlock">
        {pieChart}
      </div>
    );

  }

}

export default LabeledPieChart;
